import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import MapComponent from 'components/Map'
import { isMobile } from 'utils/helpers'
import pick from 'lodash/pick'

export const MapView = ({
  uid,
  usersTodayArray,
  classes,
  dumoDesc,
  dumoFieldValue,
  modalMode,
  taskersNow,
  breakersNow,
  startDumoTimer,
  saveInput,
  popout,
}) => (
  <div className={classes.dumoHomeContainer}>
    <div className={classes.textFieldDumo}>
      <TextField
        fullWidth
        placeholder="What would you like to work on?"
        value={dumoFieldValue}
        onChange={({ target }) => saveInput(target.value)}
      />
    </div>
    <Button
      className={classes.buttonDumo}
      onClick={() => {
        const { geolocation } = window.navigator
        geolocation.getCurrentPosition(pos => {
          if (uid.length && pos && pos.coords) {
            const { latitude: lat, longitude: lng } = pick(pos.coords, [
              'longitude',
              'latitude',
            ])
            startDumoTimer({ lat, lng })
          } else {
            startDumoTimer()
          }
        })
      }}
      variant="contained">
      Dümo
    </Button>
    <div className={classes.mapContainer}>
      <MapComponent />
    </div>
    <div>
      <ul>
        <li>There have been {usersTodayArray.length} people on Dumo today</li>
        <li>
          {taskersNow.length === 1
            ? `${taskersNow.length} person on Dumo right now`
            : `${taskersNow.length} people on Dumo right now`}
        </li>
        <li>
          {breakersNow.length} {breakersNow.length === 1 ? 'person' : 'people'}{' '}
          taking a break
        </li>
      </ul>
    </div>
    {isMobile() === false && !window.opener ? (
      <Button
        className={classes.buttonPopout}
        variant="contained"
        onClick={popout}>
        Switch to Popout Mode
      </Button>
    ) : null}
  </div>
)

MapView.propTypes = {
  classes: PropTypes.object.isRequired,
  dumoFieldValue: PropTypes.string.isRequired,
  dumoDesc: PropTypes.string.isRequired,
  saveInput: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  startDumoTimer: PropTypes.func.isRequired,
  usersTodayArray: PropTypes.array.isRequired,
  taskersNow: PropTypes.array.isRequired,
  breakersNow: PropTypes.array.isRequired,
  popout: PropTypes.func.isRequired,
  modalMode: PropTypes.bool.isRequired,
}

export default MapView



// WEBPACK FOOTER //
// ./src/components/TaskPrompt/TaskPrompt.js